import React from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { ZoomPages, ZoomViewModel } from './zoom.viewmodel';
import { connectZoomVM, ZoomContext } from './zoom.context';
import { ZoomUsersManagement } from './_zoom-users-management/zoom-users-management';
import { TrackedUsersList } from './_tracked-users-list/tracked-users-list';
import { ScheduledZoomMeetingsPage } from './_zoom-meetings/_scheduled-zoom-meetings/scheduled-zoom-meetings';
import { ScheduledZoomMeetingDetails } from './_zoom-meetings/_scheduled-zoom-meetings/_scheduled-zoom-meeting-details/scheduled-zoom-meeting-details';
import { ScheduleMeeting } from './_zoom-meetings/_schedule-new-meeting/schedule-meeting';
import { UpdateMeeting } from './_zoom-meetings/_update-meeting/update-meeting';
import {
    ScheduledZoomMeetingWebinarDetails
} from './_zoom-meetings/_scheduled-zoom-meetings/_scheduled-zoom-meeting-webinar-details/scheduled-zoom-meeting-webinar-details';
import './zoom.scss';
import { TelephoneNumberSetPage } from './_telephone-number-sets-list/telephone-number-sets-list';

interface IProps {
    selectedPage: ZoomPages;
}

const Page = ({
    selectedPage
}: IProps): JSX.Element => {
    switch (selectedPage) {
        case ZoomPages.UsersManagement:
            return <ZoomUsersManagement />;
        case ZoomPages.ScheduledMeetings:
            return <ScheduledZoomMeetingsPage />;
        case ZoomPages.ScheduledMeetingDetails:
            return <ScheduledZoomMeetingDetails />;
        case ZoomPages.ScheduledMeetingWebinarDetails:
            return <ScheduledZoomMeetingWebinarDetails />;
        case ZoomPages.ScheduleNewMeeting:
            return <ScheduleMeeting />;
        case ZoomPages.UpdateMeeting:
            return <UpdateMeeting />;
        case ZoomPages.TelephoneNumberSets:
            return <TelephoneNumberSetPage />;
        default:
            return <TrackedUsersList />;
    }
};

const ZoomPageLayout = (props: IProps) => {
    return (
        <div className='zoom-layout'>
            <h1 className='zoom-page-title zoom-layout__title'>Resources</h1>
            <Page selectedPage={props.selectedPage} />
        </div>
    );
};


const ZoomPageContainer = connectZoomVM<IProps>(ZoomPageLayout, vm => {
   return {
       selectedPage: vm.getCurrentPage(),
   };
});

const ZoomPage = moduleHost(ZoomViewModel, ZoomContext, ZoomPageContainer);

export { ZoomPage };